module.exports = __webpack_public_path__ + "img/GH-kyujin-top-025.fc98e97d.webp";